<table class="w-full divide-y divide-gray-200 mt-2">
  <thead class="bg-gray-50 sticky top-0 dark:bg-dark-background-alt dark:text-white rounded-md">
    <tr>
      <th *ngFor="let header of tableConfig" scope="col"
        class="px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer"
        [ngStyle]="{ width: header.width }">
        {{ header.label }}
      </th>
      <th *ngIf="editAction || deleteAction"
        class="px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider cursor-pointer justify-end">
        Actions
      </th>
    </tr>
  </thead>
  <tbody class="bg-white dark:bg-dark-accent dark:text-white divide-y divide-gray-200">
    <tr *ngFor="let item of jsonData; let itemIndex = index">
      <td *ngFor="let header of tableConfig" class="px-4 py-2 whitespace-nowrap text-xs"
        [ngStyle]="{ width: header.width }">
        <span [appTooltip]="header.truncate <= 15 ? item[header.field] : ''">{{
          item[header.field] | truncate: header.truncate
          }}</span>
      </td>
      <td *ngIf="editAction || deleteAction"
        class="flex flex-row px-4 py-2 text-sm font-medium text-center justify-end">
        <button *ngIf="editAction" [ngClass]="{'disabled': disabledActions}"
          class="text-blue-500 dark:text-blue-300 hover:text-blue-800 disabled:opacity-75 disabled:cursor-not-allowed"
          (click)="handleEdit(itemIndex, item)">
          <lucide-icon name="pencil"></lucide-icon>
        </button>
        <button *ngIf="deleteAction"
          class="text-red-600 hover:text-red-900 ml-4 disabled:opacity-75 disabled:cursor-not-allowed"
          [ngClass]="{'disabled': disabledActions}" (click)="handleDelete(itemIndex, item)">
          <lucide-icon name="trash-2"></lucide-icon>
        </button>
      </td>
    </tr>
  </tbody>
</table>
